export default {
    PROVIDER_TOGGLE_CAPTCHA_VIEW: 'PROVIDER_TOGGLE_CAPTCHA_VIEW',
    PROVIDER_TOGGLE_ALLOW_SUBMIT: 'PROVIDER_TOGGLE_ALLOW_SUBMIT',
    LOAD_ALL_SCHOOLS_REQUEST: 'LOAD_ALL_SCHOOLS_REQUEST',
    LOAD_ALL_SCHOOLS_SUCCESS: 'LOAD_ALL_SCHOOLS_SUCCESS',
    LOAD_ALL_SCHOOLS_FAILURE: 'LOAD_ALL_SCHOOLS_FAILURE',
    TOGGLE_INVALID_PROVIDER_EMAIL_ERROR: 'TOGGLE_INVALID_PROVIDER_EMAIL_ERROR',
    TOGGLE_PROVIDER_FAA_CERT_ERROR: 'TOGGLE_PROVIDER_FAA_CERT_ERROR'
    
}
